export enum PlannedMaintenanceImprovements {
  Increased = 0,
  Validated = 1,
  Reduced = 2,
}
